(function () {
  window.LS = window.LS || {};

  function themeRoute(name) {
    return LS.routes && LS.routes[name];
  }

  function themeString(name) {
    return (LS.strings && LS.strings[name]) || '';
  }

  function jsonOk(r) {
    if (!r.ok) throw r;
    return r.json();
  }

  LS.openCart = function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    LS.closeMenu();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  };

  LS.closeCart = function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  };

  LS.syncHeaderCount = function () {
    var drawer = document.getElementById('CartDrawer');
    var itemCount = parseInt(drawer && drawer.getAttribute('data-cart-item-count'), 10) || 0;
    var countEl = document.querySelector('#CartDrawer .cart-drawer__count');
    document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
      el.classList.toggle('cart-link--empty', itemCount === 0);
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = countEl ? countEl.textContent : '';
    });
  };

  LS.refreshCart = function () {
    var root = themeRoute('root');
    return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(jsonOk)
      .then(function (json) {
        var html = json['cart-drawer'];
        var el = document.getElementById('shopify-section-cart-drawer');
        var drawer = document.getElementById('CartDrawer');
        var wasOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
        if (el && html) el.outerHTML = html;
        if (wasOpen) LS.openCart();
        LS.syncHeaderCount();
        document.dispatchEvent(new CustomEvent('ls:cart-refreshed'));
      })
      .then(function () {
        if (!document.getElementById('shopify-section-main')) return;
        var cartUrl = themeRoute('cart');
        var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
        var cartPath = cartUrl.replace(/\/+$/, '');
        if (path !== cartPath) return;
        return fetch(cartUrl + '?sections=main', { headers: { Accept: 'application/json' } })
          .then(jsonOk)
          .then(function (json) {
            var html = json.main;
            var el = document.getElementById('shopify-section-main');
            if (el && html) el.outerHTML = html;
          });
      });
  };

  LS.openMenu = function () {
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    LS.closeCart();
    nav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
    var first = nav.querySelector('a, button');
    if (first) first.focus();
  };

  LS.closeMenu = function () {
    var nav = document.getElementById('MobileNav');
    if (!nav || nav.getAttribute('aria-hidden') === 'true') return;
    nav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  };

  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.language-switcher[open]').forEach(function (switcher) {
      if (!switcher.contains(e.target)) switcher.removeAttribute('open');
    });

    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      LS.openCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      LS.closeCart();
      return;
    }
    if (e.target.closest('[data-menu-toggle]')) {
      e.preventDefault();
      var nav = document.getElementById('MobileNav');
      if (nav && nav.getAttribute('aria-hidden') === 'false') LS.closeMenu();
      else LS.openMenu();
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      LS.closeMenu();
      return;
    }

    var qty = e.target.closest('[data-qty-change]');
    if (qty) {
      var item = qty.closest('.cart-drawer__item');
      if (!item) return;
      var delta = qty.getAttribute('data-qty-change');
      var key = item.getAttribute('data-key');
      var valueEl = item.querySelector('.cart-drawer__qty-value');
      var current = parseInt(valueEl && valueEl.textContent, 10) || 1;
      var next = (delta === 'remove') ? 0 : Math.max(0, current + parseInt(delta, 10));
      fetch(themeRoute('cartChange'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      })
        .then(jsonOk)
        .then(function () { return LS.refreshCart(); })
        .catch(function () { /* qty Liquid unchanged */ });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var languageSwitcher = document.querySelector('.language-switcher[open]');
    if (languageSwitcher) {
      languageSwitcher.removeAttribute('open');
      var languageTrigger = languageSwitcher.querySelector('summary');
      if (languageTrigger) languageTrigger.focus();
      return;
    }
    var drawer = document.getElementById('CartDrawer');
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      LS.closeCart();
      return;
    }
    LS.closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var nav = document.getElementById('MobileNav');
    if (!nav || nav.getAttribute('aria-hidden') !== 'false') return;
    var focusable = nav.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-to-cart]')) return;
    var submitter = e.submitter;
    if (submitter && (submitter.closest('.shopify-payment-button') || submitter.getAttribute('name') === 'checkout')) {
      return;
    }
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var id = parseInt(idInput.value, 10);
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      var m = input.name.match(/^properties\[([^\]]+)\]$/);
      if (m && input.value) props[m[1]] = input.value;
    });
    var buy = document.getElementById('cta-buy') || form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    var sticky = document.getElementById('sticky-cta-btn');
    var status = document.getElementById('cta-status');
    form.setAttribute('aria-busy', 'true');
    if (buy) buy.disabled = true;
    if (sticky) sticky.disabled = true;

    function restoreCta() {
      form.removeAttribute('aria-busy');
      if (buy && !buy.hasAttribute('data-force-disabled')) buy.disabled = false;
      if (sticky && !sticky.hasAttribute('data-force-disabled')) sticky.disabled = false;
    }

    var payload = { id: id, quantity: quantity };
    if (Object.keys(props).length) payload.properties = props;

    fetch(themeRoute('cartAdd'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(jsonOk)
      .then(function () {
        var packagingInput = form.querySelector('[name="attributes[Emballage]"]');
        var packagingValue = packagingInput ? packagingInput.value : themeString('neutralPackaging');
        return fetch(themeRoute('cartUpdate'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              Emballage: packagingValue
            }
          })
        });
      })
      .then(function () { return LS.refreshCart(); })
      .then(LS.openCart)
      .then(function () {
        if (status) { status.hidden = false; status.textContent = themeString('addedToCart'); }
        setTimeout(function () { if (status) status.hidden = true; restoreCta(); }, 1500);
      })
      .catch(function () {
        if (status) { status.hidden = false; status.textContent = themeString('unavailable'); }
        restoreCta();
      });
  });

  initReveal();
})();
